module.exports = __webpack_public_path__ + "static/media/model-05.26d0e864.jpg";